import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CdkAriaLive } from '@angular/cdk/a11y';
import { MatProgressBarModule, ProgressBarMode } from '@angular/material/progress-bar';

@Component({
  selector: 'app-biq-progress-bar',
  imports: [
    MatProgressBarModule,
    CdkAriaLive,
  ],
  templateUrl: './progress-bar.component.html',
  styleUrl: './progress-bar.component.css'
})
export class ProgressBarComponent implements OnChanges {
  mode: ProgressBarMode = 'determinate';
  value = 0;
  @Input() questNo!: number;
  @Input() totalQuestions!: number;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['questNo']) {
      this.value = (this.questNo + 1) * 100 / this.totalQuestions; 
    }
  }
}
